<template>
  <v-main>
    <v-layout>
      <v-container fluid fill-height column v-if="user">
        <v-layout v-if="user.emailVerified" justify-center row wrap >
          <v-flex v-if="subedToPhoneLine" class="pa-4" xs12 sm10 md6 lg6 >
            <phone-numbers-list v-if="subedToPhoneLine"></phone-numbers-list>
          </v-flex>
          <v-flex v-if="subedToBooking" class="pa-4" xs12 sm10 md6 lg6 >
           <calender-app></calender-app>
          </v-flex>
          <v-flex v-if="subedToPayments" class="pa-4" xs12 sm10 md6 lg6 >
            <transactions-graph></transactions-graph>
          </v-flex>
        </v-layout>
        <v-layout v-else justify-center row wrap >
          <v-flex class="pa-4" xs12 sm10 md6 lg6 >
          <v-card>
            <v-card-title>
              Confirm email
            </v-card-title>
            <v-card-subtitle>
              Verify your email address to continue.
            </v-card-subtitle>
            <v-card-text class="headline font-weight-light">
              <v-icon>email</v-icon>{{user.email}}
            </v-card-text>
            <v-card-text v-if="emailVerificationLoading" class="font-weight-regular">
                Check your inbox for verification email.
            </v-card-text>
            <v-card-actions class="pb-6" v-if="!verificationEmailSent">
              <v-btn @click="sendVerificationEmail"
                     class="blue white--text"
                     :disabled="emailVerificationLoading"
              >
                <v-progress-circular
                    v-if="emailVerificationLoading"
                    indeterminate
                    :size="25"
                    color="black"
                ></v-progress-circular>
                Send Verification email
              </v-btn>
            </v-card-actions>
            <v-card-text class="subtitle-1 font-weight-light" v-else>
              <v-icon>check</v-icon>Verification Email Sent.
            </v-card-text>
          </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid fill-height column v-else>
        <v-layout justify-center row wrap>
          <v-flex  xs12 sm10 md8>
            <v-img
                alt="Flexline logo"
                flex
                @click="routeToLandingPage"
                src="../assets/logo.svg"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>

  </v-main>

</template>

<script>
import {getFunctions, httpsCallable} from 'firebase/functions';

export default {
  data: () => ({
    emailVerificationLoading: false,
    verificationEmailSent: false,
    subedToPhoneLine: false,
    subedToBooking:false,
    subedToPayments: false
  }),
  computed: {
    subscriptions () {
      return this.$store.getters.subscriptions
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    subscriptions () {
      this.setDashboardApps()
    }
  },
  created () {
    if (this.subscriptions) {
      this.setDashboardApps()
    }
  },
  methods: {
    setDashboardApps () {
      let subs = this.subscriptions
      if (subs.length > 0) {
        subs.forEach(sub => {
          if (sub.id === 'bookings') {
            this.subedToBooking = true
          }
          if (sub.id === 'flexlinePhoneNumber') {
            this.subedToPhoneLine = true
          }
          if (sub.id === 'payments') {
            this.subedToPayments = true
          }
        })
      }
    },
    routeToLandingPage () {
      window.open('https://flexline.app/')
    },
    formatPhoneNumber(phoneNumberString) {
      // console.log(phoneNumberString)
      let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        let intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      }
      return null;
    },
    sendVerificationEmail () {
      this.emailVerificationLoading = true
      const functions = getFunctions();
      const sendEmailVerification = httpsCallable(functions, 'sendEmailVerification')

      return sendEmailVerification({email: this.user.email, type:'verifyEmail' }) // verifyEmail or resetPassword
          .then(res => {
            if (res.data) {
             console.log(res.data)
             console.log('email sent')
              this.emailVerificationLoading = false
              this.verificationEmailSent = true
            }
          })
          .catch(err => {
            console.log(err)
            this.emailVerificationLoading = false
            this.verificationEmailSent = false
            this.$store.dispatch('setError', err)
          })
    },
    goToNumberDash(selectedNumber) {
      //console.log(selectedNumber)
      if(selectedNumber.status.type !== 'active'){
        this.newNumberDialog = true
        this.selectedNumberMessage = selectedNumber.status.message
      } else {
        this.$router.push('/numberPortal/' + selectedNumber.phoneNumber)
      }

    }
  }

}
</script>
